import React, { useEffect } from 'react'
import HeaderSec from '../../Components/HeaderSec/HeaderSec'
import FooterComp from '../../Components/FooterComp/FooterComp'
import ContactLanding from '../../Components/PageComponents/ContactUs/ContactLanding/ContactLanding'
import ContactMap from '../../Components/PageComponents/ContactUs/ContactMap'

const ContactUs = () => {
  useEffect(() => {
          window.scrollTo(0, 0);
      }, []);
  return (
    <div className='max-w-screen overflow-hidden'>
        <HeaderSec/>
        <ContactLanding/>
        <ContactMap/>
        <FooterComp/>
    </div>
  )
}

export default ContactUs